import { ConfigProvider } from "antd";
import enUS from "antd/locale/en_US";
import idID from "antd/locale/id_ID";
import dayjs from "dayjs";
import "dayjs/locale/id";
import { useTranslation } from "react-i18next";
import "@ant-design/v5-patch-for-react-19";
import "./App.css";
import { theme } from "./core/theme/Theme";
import { UserProvider } from "./context/User.context";
import { LanguageProvider } from "./context/Language.contex";
import MainRouter from "./core/router/router";

const antdLocales = { en: enUS, id: idID };

function AppInner() {
  const { i18n } = useTranslation();
  const lang = i18n.language?.split("-")[0] || "en";
  dayjs.locale(lang === "id" ? "id" : "en");

  return (
    <ConfigProvider theme={theme} locale={antdLocales[lang] || enUS}>
      <MainRouter />
    </ConfigProvider>
  );
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <UserProvider>
          <AppInner />
        </UserProvider>
      </LanguageProvider>
    </div>
  );
}

export default App;
